import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Bot, User, AlertTriangle, Link2 } from "lucide-react";
import { TYPE_META, PRIORITY_META, actorLabel } from "./taskConstants";

export function TaskCard({ task, onClick, dragProvided, dragSnapshot }) {
  const typeMeta = TYPE_META[task.type] || { label: task.type, color: "bg-muted text-muted-foreground" };
  const prioMeta = PRIORITY_META[task.priority] || {};
  const assignee = task.assignee;

  return (
    <div ref={dragProvided?.innerRef} {...(dragProvided?.draggableProps || {})} {...(dragProvided?.dragHandleProps || {})}>
      <Card
        className={`select-none ${dragSnapshot?.isDragging ? "shadow-xl rotate-1 opacity-95" : "cursor-pointer hover:shadow-md"}`}
        onClick={onClick}
        data-testid={`task-card-${task.id}`}
      >
        <CardContent className="p-3 space-y-1.5">
          <div className="flex items-start justify-between gap-1">
            <p className="font-medium text-sm leading-snug line-clamp-2">{task.title}</p>
            {task.status === "blocked" && <AlertTriangle className="w-3.5 h-3.5 text-red-500 flex-shrink-0 mt-0.5" data-testid={`task-blocked-icon-${task.id}`} />}
          </div>
          <div className="flex items-center gap-1.5 flex-wrap">
            <Badge className={`text-[10px] px-1.5 py-0 border-0 ${typeMeta.color}`}>{typeMeta.label}</Badge>
            {task.priority && <Badge className={`text-[10px] px-1.5 py-0 border-0 ${prioMeta.color || ""}`}>{task.priority}</Badge>}
          </div>
          <div className="flex items-center justify-between pt-0.5">
            {assignee ? (
              <span className="flex items-center gap-1 text-[11px] text-muted-foreground truncate">
                {assignee.kind === "agent" ? <Bot className="w-3 h-3 flex-shrink-0" /> : <User className="w-3 h-3 flex-shrink-0" />}
                <span className="truncate max-w-[120px]">{actorLabel(assignee)}</span>
              </span>
            ) : (
              <span className="text-[11px] text-muted-foreground italic">Sin asignar</span>
            )}
            {task.initiative_id && <Link2 className="w-3 h-3 text-muted-foreground flex-shrink-0" data-testid={`task-linked-initiative-${task.id}`} />}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
